import * as angular from 'angular';

import PivotTableController from './pivot-table-controller';

const PivotTableComponent: angular.IComponentOptions = {
  controller: PivotTableController,
  controllerAs: 'ctrl',
  bindings: {
    view: '<',
    dataset: '<',
    chartID: '@id',
    onAction: '&',
    onEdit: '&',
    onRenderStart: '&',
    onRenderEnd: '&',
    chartOptions: '<',
    panelEnabled: '=',
    viewer: '<',
    isChartVisible: '<',
  },
  template: `
    <div
      class="editor-module editor-chart mode-object editor-multi pivot-table"
      ng-class="ctrl.getDOMClasses()" >
        <!-- Chart Content Begins -->
        <div
          class="chart-content"
          ng-show="!ctrl.isEmptyStateInDesigner()">
          <!-- Component Header Begins -->
          <div
            class="chart-header"
            ng-class="{ 'has-open-panel': ctrl.panelEnabled }"
            ng-show="!(ctrl.isDesignerMode() && ctrl.dataExceedsLimit())"
          >

            <span class="lightbox-title" ng-class="{'chart-title': ctrl.isDesignerMode()}">
              <in-place-edit
                text="ctrl.view.chartTitle"
                alt-text="Click to add title"
                on-change="ctrl.updateChartTitle($text)"
                no-edit="ctrl.titleEditDisabled()"
              ></in-place-edit>
            </span>
            <!-- New Menu Actions Begin -->
            <div class="new-viz-actions" ng-if="!(ctrl.isDesignerMode() || ctrl.viewer === 'whiteLabel')">
            <copy-link-to-viz link="ctrl.getReportVizURL()">
                <button
                  class="new-viz-action hide-2"
                  uib-tooltip="Get Share Link"
                  copy-to-clipboard
                  clipboard-text="ctrl.getReportVizURL()"
                  clipboard-success="ctrl.copySuccess()"
                  clipboard-enabled="isClipboardEnabled">
                  <svg-icon type="'copy-link'"></svg-icon>
                </button>
              </copy-link-to-viz>

              <button class="new-viz-action" ng-if="ctrl.dataset">
                <kebab-menu targetable="true">
                  <li menu-item="exp" ng-click="ctrl.linkTo($event, 'query')" ng-href="{{ ctrl.dataset.reportQueryUrl }}" ng-if="!ctrl.viewer">View Query <span class="mode-show-embed-inline">in Mode</span></li>
                  <li menu-item="exp" ng-click="ctrl.linkTo($event, 'data')" ng-href="{{ ctrl.dataset.reportDataUrl }}">View Query Results <span class="mode-show-embed-inline">in Mode</span></li>
                </kebab-menu>
              </button>

              <div class="new-viz-actions__section" ng-if="!ctrl.viewer">
                <span class="divider"></span>

                <a class="new-viz-action"
                  ng-if="ctrl.plan === 'plus'"
                  ng-href="{{ ctrl.getReportVizURL() }}"
                  ng-click="ctrl.togglePanel($event)">
                  <svg-icon class="mode-hide-embed" type="'toggle-explorer'" uib-tooltip="Explore"></svg-icon>
                  <svg-icon class="mode-show-embed-flex-inline" type="'toggle-explorer'" uib-tooltip="Explore in Mode" tooltip-placement="left"></svg-icon>
                </a>

                <a class="new-viz-action"
                  ng-if="ctrl.plan !== 'plus'"
                  ng-href="{{ ctrl.getReportVizURL() }}"
                  ng-click="ctrl.togglePanel($event)">
                  <svg-icon class="mode-hide-embed" type="'toggle-expanded-view'" uib-tooltip="Explore"></svg-icon>
                  <svg-icon class="mode-show-embed-flex-inline" type="'toggle-expanded-view'" uib-tooltip="Explore in Mode" tooltip-placement="left"></svg-icon>
                </a>
              </div>
            </div>
            <!-- New Menu Actions End -->

          </div>
          <!-- @Component Header Ends -->

          <!-- Component Body Begins -->
          <div class="chart-body" ng-show="!ctrl.dataExceedsLimit()">

            <!-- Pivot Table Container Begins -->
            <div id="js-pivot-table-container" class="mode-table-grid pivot-table-container row-key-cnt-{{ctrl.view.pivotTable.rows.length}}" ></div>
            <!-- @Pivot Table Container Ends -->

          </div>
          <!-- @Component Body Ends -->

          <!-- Side Column Begins -->
          <div
            id="js-side-panel"
            class="side-panel chart-sidebar"
            ng-if="ctrl.panelEnabled && !ctrl.isBuilderMode()">

            <!-- Pivot Table Settings Begin -->
            <pivot-table-settings
              ng-cloak
              token="::ctrl.chartID"
              data="ctrl.dataset"
              view="ctrl.view.pivotTable"
              container-height="ctrl.containerHeight()"
              on-settings-update="ctrl.updateView($view)">
            </pivot-table-settings>
            <!-- @Pivot Table Settings End -->

          </div>
          <!-- @Side Column Ends -->

        </div>
        <!-- @Chart Content Ends -->

        <!-- Intermediary Messages Begins -->
        <div ng-if="ctrl.dataState('cancelled')" class="error-message">
          <i class="icon-warning-small error-icon"></i>
          <div class="message">This query was canceled</div>
          <div class="sub-message"></div>
        </div>
        <div ng-if="ctrl.isEmptyStateInDesigner() && !ctrl.dataExceedsLimit()" class="error-message error-empty-message">
          <div class="message">
            <h2 class="heading">To create a pivot table, drag fields from the list on the right.</h2>
          </div>
          <div class="hero">
            <i class="icon-pivot-empty-state"></i>
          </div>
        </div>
        <div ng-if="ctrl.contentAreaExceedsLimit()" class="error-message error-cant-render-message">
          <div class="message">
            <h2 class="heading">This pivot table will be too large to display!</h2>
            <h3 class="summary">Try using fields with fewer options</h3>
          </div>
          <div class="hero">
            <i class="icon-performance-table"></i>
          </div>
        </div>
        <div class="chart-error" ng-show="ctrl.dataExceedsLimit()">
          <h3>Sorry, unable to render a chart with the given data</h3>
          <p>{{ ctrl.message.limit_exceeded }}</p>
        </div>
        <!-- @Intermediary Messages End -->

    </div>
  `,
};

export { PivotTableComponent };
